import type { Editor } from "@tiptap/core";
import { setPlaybookPending } from "./collaborateEditorStorage";
import {
  deleteChipRanges,
  hasSignoffBadge,
  removeAllCommandChips,
} from "./collaborateSignoffChips";

export function hasPlaybookBadge(editor: Editor): boolean {
  let found = false;
  editor.state.doc.descendants((node) => {
    if (node.type.name === "playbookBadge") {
      found = true;
    }
  });
  return found;
}

export function removePlaybookBadgeNodes(editor: Editor): void {
  deleteChipRanges(editor, new Set(["playbookBadge"]));
}

export function removePlaybookAssigneeNodes(editor: Editor): void {
  deleteChipRanges(editor, new Set(["playbook"]));
}

export function removePlaybookChips(editor: Editor): void {
  deleteChipRanges(editor, new Set(["playbookBadge", "playbook"]));
}

export function insertPlaybookBadge(editor: Editor): void {
  removeAllCommandChips(editor);
  editor
    .chain()
    .focus()
    .insertContent([{ type: "playbookBadge" }, { type: "text", text: " " }])
    .run();
  setPlaybookPending(editor, true);
}

/** Keep update-playbook mode in sync when the badge is deleted (e.g. Backspace). */
export function syncPlaybookPendingFromDoc(editor: Editor): void {
  if (!hasPlaybookBadge(editor)) {
    setPlaybookPending(editor, false);
  }
}

export function hasCommandBadge(editor: Editor): boolean {
  return hasSignoffBadge(editor) || hasPlaybookBadge(editor);
}
